import React, { Component } from "react"; 
import requester from '../lib/requester'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import logo from '../assets/img/traces_new.png'

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      loading: false,
      error: [] 
    }
  }

  componentDidMount = () => {
    window.localStorage.removeItem('is_token')
    window.localStorage.removeItem('is_user')
    if (this.props.location.search === '?unauthorize') {
      let error = ['Unauthorized, please login']
      this.setState({ error: error })
    }
  }

  handleLogin = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    let error = []
    if (this.state.username.length === 0) {
      error.push('Username can\'t be blank')
    }
    if (this.state.password.length === 0) {
      error.push('Password can\'t be blank')
    }
    if (error.length === 0) {
      let url = '/api/infostep/v1/auth/login'
      let param = { username: this.state.username, password: this.state.password }
      requester.postInfostep(url, param, {
        success: function (response) {
          let { token, user } = response.data.data
          if (token) {
            let data = {
              org_name: user.org_name,
              org_type: user.org_type,
              realname: user.realname,
              role_name: user.role_name,
              username: user.username,
              user_id: user.user_id,
              org_id: user.org_id,
              org_initial: user.org_initial
            }
            window.localStorage.setItem('is_token', token)
            window.localStorage.setItem('is_user', JSON.stringify(data))
            this.setState({ loading: false })
            window.location.href = '/admin/dashboard'
          } else {
            let { message } = response.data
            let error = message && message.length > 0 ? [message] : 'Failed to login'
            this.setState({ error: error, loading: false })
          }
        }.bind(this),
        error: function (e) {
          let error = 'Failed to login, please try again'
          console.log(e)
          this.setState({ error: [error], loading: false })
        }.bind(this)
      })
    } else {
      this.setState({ error: error, loading: false })
      return false
    }
  }

  handleChangePass = (e) => {
    e.preventDefault()
    // this.setState({ loading: true })
    // let error = []

    // this.setState({ loading: false })
    window.location.href = '/changepass'
    // alert ("OK")

  }

  handleInputUsername = (e) => {
    this.setState({ username: e.target.value })
  }

  handleInputPassword = (e) => {
    this.setState({ password: e.target.value })
  }

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return (<li key={index}>{item}</li>)
            })}
          </ul>
        </div>
      )
    }
  }

  render() {
    return (
      <div className="container-fluid container-login100 bg">
        <div className="row">
          <div className="col-md-4 col-lg-4 col-sm-12 mx-auto mt-5">
            <div className="card custom-card">
              <div className="card-body p-5 montserrat">
                {this.showError()}
                <div className="row">
                  <div className="mx-auto">
                    <img src={logo} width="200" />
                  </div>
                </div>
                <div className="row mb-4">
                  {/* <div className="col-md-12 text-center text-secondary">CICD note</div> */}
                  <div className="col-md-12 text-center text-secondary">Sign in to start your session</div>
                </div>
                <form onSubmit={this.handleLogin.bind(this)}>
                  <div className="form-group">
                    <span className="icon-span">
                      <i className="fas fa-user text-secondary"></i>
                    </span>
                    <input type="text" className="form-control icon-input" id="formGroupExampleInput" autoComplete="off" placeholder="Username" onChange={this.handleInputUsername.bind(this)} />
                  </div>
                  <div className="form-group">
                    <span className="icon-span">
                      <i className="fas fa-unlock text-secondary"></i>
                    </span>
                    <input type="password" className="form-control icon-input" id="formGroupExampleInput2" placeholder="Password" onChange={this.handleInputPassword.bind(this)} />
                  </div>
                  <button type="submit" className="btn btn-primary btn-block" onClick={() => { this.handleLogin.bind(this) }}>Login</button>&nbsp;
                </form>
                {/* <button type = "button" className="btn btn-secondary" onClick={ this.handleChangePass.bind(this) }>Change Password</button> */}
              </div>
            </div>
          </div> 
        </div>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default Login
